export interface IProps {}

export enum PageSection {
  ORGANIZE = "organize",
  ATTRIBUTIONS = "attributions",
  MISSION = "mission",
  PERSONNEL = "personnel",
  PROJECTS = "projects",
  PARTNERS = "partners",
  REPORTS = "reports",
  MANAGEMENT = "management",
}
